export default __webpack_public_path__ + "static/media/tab_lecturer2_large.c0b7e837.png";